import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPositions } from "~shared/modules/tooltip/models/tooltip-positions.model";

@Component({
  selector: 'app-vat-disclaimer-plps',
  templateUrl: './vat-disclaimer-plps.component.html',
  styleUrls: ['./vat-disclaimer-plps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VatDisclaimerPLPsComponent {
  @Input()
  isDesktop: boolean;

  TOOLTIP_POSITION_MOBILE: TooltipPositions = TooltipPositions.left;
  TOOLTIP_POSITION_DESKTOP: TooltipPositions = TooltipPositions.right;
}
